import Link from 'next/link';

import useLocale from '@/src/hooks/useLocale';
import useRoutePaths from '@/src/hooks/useRoutePaths';
import TextLocal from '@/src/textLocal/containers/TextLocal';

import {LanguageSwitcher, Text} from '../../../ui';
import css from '../styles/Footer.module.css';

const Footer = () => {
  const {currentLocale, handleChangeLang} = useLocale();
  const year = new Date().getFullYear();
  const {PRIVACY_POLICY_ROUTE, TERMS_AND_CONDITIONS_ROUTE, IMPRINT_ROUTE} =
    useRoutePaths();

  return (
    <footer className={css.footer}>
      <div className={css.copyright}>
        <Text fontSize={Text.FONT_SIZE.SIZE_14} color={Text.COLOR.GREY}>
          © {year} <TextLocal id={'general.company-name'} />
        </Text>
      </div>

      <div className={css.terms}>
        <Link href={TERMS_AND_CONDITIONS_ROUTE.getLink()}>
          <a>
            <Text fontSize={Text.FONT_SIZE.SIZE_14} color={Text.COLOR.GREY}>
              <TextLocal id={'footer.terms-conditions'} />
            </Text>
          </a>
        </Link>
        <Link href={PRIVACY_POLICY_ROUTE.getLink()}>
          <a>
            <Text fontSize={Text.FONT_SIZE.SIZE_14} color={Text.COLOR.GREY}>
              <TextLocal id={'footer.privacy-policy'} />
            </Text>
          </a>
        </Link>
        <Link href={IMPRINT_ROUTE.getLink()}>
          <a>
            <Text fontSize={Text.FONT_SIZE.SIZE_14} color={Text.COLOR.GREY}>
              <TextLocal id={'footer.imprint'} />
            </Text>
          </a>
        </Link>
      </div>

      <div className={css.landSwitcher}>
        <LanguageSwitcher
          color={LanguageSwitcher.COLORS.PRIMARY}
          activeLocale={currentLocale}
          onChange={handleChangeLang}
        />
      </div>
    </footer>
  );
};

export default Footer;
